import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

const LightBulbIcon = ({
  width = styleConfigs.dimensions.width50,
  height = styleConfigs.dimensions.height50,
  color = COLORS.greenPathCourses,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={width}
    height={height}
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M20 23V26C20 27.1046 19.1046 28 18 28H14C12.8954 28 12 27.1046 12 26V23"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path d="M16 1V3" stroke={color} strokeWidth={1.5} strokeLinecap="round" fill="none" />
    <path d="M2 15H4" stroke={color} strokeWidth={1.5} strokeLinecap="round" fill="none" />
    <path d="M5 5L6.46667 6.40933" stroke={color} strokeWidth={1.5} strokeLinecap="round" fill="none" />
    <path d="M30 15H28" stroke={color} strokeWidth={1.5} strokeLinecap="round" fill="none" />
    <path d="M26.9999 5L25.5332 6.40933" stroke={color} strokeWidth={1.5} strokeLinecap="round" fill="none" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8854 23H20.1121C23.144 21.4951 25.044 18.3846 24.9988 15C24.9112 10.0662 20.9326 6.08753 15.9988 6C11.0629 6.08762 7.08346 10.0694 6.99877 15.0053C6.95559 18.388 8.85529 21.4959 11.8854 23V23Z"
      fill="none"
      stroke={color}
      strokeWidth={1.5}
    />
    <path d="M16 28V31" stroke={color} strokeWidth={1.5} fill="none" />
    <path d="M16 18V23" stroke={color} strokeWidth={1.5} fill="none" />
    <path d="M13 15L16 18L19 15" stroke={color} strokeWidth={1.5} fill="none" />
  </svg>
);

export default LightBulbIcon;
